import { Component, Input } from "@angular/core";

@Component({
    selector: "app-text-with-image",
    templateUrl: "./text-with-image.component.html",
    styleUrls: ["./text-with-image.component.scss"],
    standalone: false
})
export class TextWithImageComponent {
    @Input() public side: "left" | "right" = "left";
    @Input({required: true}) public imageUrl!: string;
}